import React from 'react';
import { CommandBarButton, IconButton } from '@fluentui/react';
import DetailsTable from '../../../Table/DetailsTable';
import FeatureSummary from '../../../Util/FeatureSummary';

const WebinarsTable = ({
    webinars,
    setSelectedWebinar,
    loading,
    editOnClick,
    createOnClick,
    previewOnClick,
    deleteOnClick,
}) => {
    const columns = [
        {
            minWidth: 30,
            maxWidth: 30,
            onRender: (item) => (
                <ContextualMenu editOnClick={editOnClick} previewOnClick={previewOnClick} id={item.webinarId} deleteOnClick={deleteOnClick} />
            ),
        },
        {
            name: 'webinarId',
            fieldName: 'webinarId',
            minWidth: 80,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Title',
            fieldName: 'title',
            minWidth: 400,
            maxWidth: 450,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Platform',
            fieldName: 'platformId',
            minWidth: 80,
            maxWidth: 120,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
            onRender: (item) => item.platformId === 1 ? 'iGrad' : 'Enrich',
        },
        {
            name: 'Webinar Date UTC',
            fieldName: 'webinarDateTimeAsUtc',
            minWidth: 200,
            maxWidth: 250,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Publish Date',
            fieldName: 'publishDate',
            minWidth: 200,
            maxWidth: 250,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
        {
            name: 'Publish Status',
            fieldName: 'publishStatus',
            minWidth: 200,
            maxWidth: 250,
            isResizable: true,
            isSorted: true,
            isSortedDescending: true,
        },
    ];

    const items = webinars ?? [];

    const selectionHook = (items) => {
        setSelectedWebinar(items && items[0] && items[0].webinarId);
    };

    return (
        <>
            <DetailsTable
                items={items}
                columns={columns}
                selectionMode="none"
                selectionHook={selectionHook}
                loading={loading}
                mainColumn={'name'}
                style={{
                    position: 'relative',
                    height: '80vh',
                    width: '80vw',
                }}
                CommandBar={
                    <CommandBarButton
                        iconProps={{ iconName: 'Edit' }}
                        text="Add Webinar"
                        onClick={() => createOnClick()}
                    />
                }
            />
            <FeatureSummary
                label="About Webinars"
                summary="This table lists all webinars available on the platform, including their title, platform, and scheduled date. You can add, edit, or delete webinars. Webinars are used to educate and engage users on various financial topics."
            />
        </>
    );
};

const moreIcon = { iconName: 'More' };

const ContextualMenu = ({ editOnClick, deleteOnClick, id, ...rest }) => {
    const menuProps = {
        items: [
            {
                key: 'print',
                iconProps: { iconName: 'Edit' },
                text: 'Edit',
                onClick: () => editOnClick(id),
            },
            {
                key: "Delete",
                iconProps: { iconName: "Delete" },
                text: "Delete",
                onClick: () => deleteOnClick(id),
            },
        ],
    };

    return <IconButton iconProps={moreIcon} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
};

export default WebinarsTable;
